import { Component, OnInit } from '@angular/core';
import { pageChange } from './shared/pageChange.animation';
import { RouterChangeService } from './shared/services/router-change.service';
import { DialogService } from './shared/services/dialog.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  animations: [pageChange]
})
export class AppComponent implements OnInit {
  public animationsDisabled = true;

  constructor(public rc: RouterChangeService, private dialog: DialogService) {}

  ngOnInit() {
    if (!environment.production && !location.href.includes('localhost:4200'))
      setTimeout(
        () =>
          this.dialog
            .confirm(
              'אתר זה הוא בטא',
              'אתר זה מיועד לבדיקות ופיתוח. אין להשתמש באתר לצרכים אמיתיים.',
              'לאתר הרשמי',
              'לאתר הבטא'
            )
            .then(v => {
              if (v) location.href = 'https://' + environment.coreDomain;
            }),
        0
      );

    setTimeout(() => (this.animationsDisabled = false), 1000);
  }
}
